import { MasterDataResponse } from "../../../types/api-response";
export const masterDataInitialState: MasterDataResponse = (() => {
  return {
    topCities: [],
    internationalLocations: [],
    regionAndStates: [],
    allFunctions: [],
    topIndustriesList: [],
    otherIndustriesList: [],
    topIndustryClusters: [],
    languages: undefined,
    topEducationClusters: [],
    eduStreamData: [],
    educationData: [],
    removeEduStreams: undefined,
    topCollegeClusters: undefined,
    citizenship: [],
    currency: [],
    differentlyAbled: undefined,
    noticePeriod: [],
    usVisa: undefined,
    visaStatus: undefined,
    filterInsights: undefined,
    gradCluster: undefined,
    topFunctions: [],
  };
})();
